// extracted by mini-css-extract-plugin
export default {"master_filter":"AppointmentsFilters_master_filter__1WlwE"};